var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 29.8c1 0 1.8 1.7 1.9 3.9v.1c0 3.4-.3 11.6-.3 11.6s-.1 2.6-1.6 2.6c-1.1 0-2.9-.2-3.7-.3-.9-.1-1.7-1.7-1.7-3.6v-.2c0-3.1.4-11.3.4-11.3s.1-2.8 1.7-2.8h3.3Zm36.7.1c-.8 0-1.5 1.7-1.5 3.8v.1c0 20.7-.4-11.2.2 11.6 0 0 .1 2.7 1.3 2.7.9 0 2.4-.2 3-.3.7-.1 1.4-1.7 1.4-3.6V44c0-3.1-.3-11.3-.3-11.3s-.1-2.8-1.4-2.8h-2.7ZM40 65.9c1.657 0 3-1.433 3-3.2 0-1.767-1.343-3.2-3-3.2s-3 1.433-3 3.2c0 1.767 1.343 3.2 3 3.2Z",
    fill: "#F09103"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 30.5S23.8 12.1 40 12.1c16.9 0 18.8 19 18.8 19",
    stroke: "#165297",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29.8s.5-1.7 3.7-1.7c3.3 0 3.7 1.8 3.7 1.8m8.9-.1s.5-1.7 3.7-1.7c3.3 0 3.7 1.8 3.7 1.8M38.6 64.8C23.6 64 23 49.2 21.9 49.3M39.5 28s2.1 12.3.3 12.3L39.5 28Z",
    stroke: "#165297",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 30.9c1-.1 2 1.6 2.1 3.7v.1c.3 3.4.6 11.6.6 11.6s.1 2.7-1.4 2.8c-1.1.1-2.9 0-3.7-.1-.9-.1-1.8-1.5-1.9-3.5v-.2c-.2-3.1-.4-11.3-.4-11.3s-.1-2.8 1.5-3l3.2-.1v0Zm37.7.1c-.8 0-1.6 1.7-1.6 3.8v.2c-.5 20.7-.1-11.2-.1 11.6 0 0 0 2.7 1.2 2.7.9 0 2.4-.2 3-.3.8-.1 1.4-1.6 1.5-3.6v-.2c.1-3.1 0-11.3 0-11.3s0-2.8-1.3-2.9h-2.7v0Z",
    stroke: "#165297",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 68c1.657 0 3-1.433 3-3.2 0-1.767-1.343-3.2-3-3.2s-3 1.433-3 3.2c0 1.767 1.343 3.2 3 3.2Z",
    fill: "#165297"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.27cd8f162db950170def2ec697e709b6.svg";
export { ForwardRef as ReactComponent };